import React from 'react'
import { I18n } from '@front/volcanion/'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'

import {
  TextField,
  MenuSelectorField,
  ModelMenuSelectorField,
  SingleOptionSelectorField
} from '@front/squirtle/'

const Row1 = props => (
  <Grid container spacing={2} alignItems='flex-end' size={12}>
    <Grid size={5}>
      <TextField
        name={'name'}
        label={I18n.t('name.label', { count: 1 })}
        required
      />
    </Grid>

    <Grid size={2}>
      <MenuSelectorField
        label={I18n.t('load.label', { count: 1 })}
        name={'load_type'}
        selectFirst
        options={[
          { label: I18n.t('load.user.label', { count: -1 }), value: 'user' },
          { label: I18n.t('load.package.label', { count: -1 }), value: 'package' }
        ]}
        required
      />
    </Grid>
    <Grid size={3}>
      <ModelMenuSelectorField
        name={'application'}
        label={I18n.t('application.label.alter')}
        model_name='application'
        labelKeys={['name']}
        loadOnMount
        searchMode={'search'}
        required
      />
    </Grid>
  </Grid>
)

const Row2 = props => (
  <Grid container spacing={2} alignItems='flex-end' size={12}>
    <Grid size="grow">
      <TextField
        name={'client_type_icon'}
        label={I18n.t('icon')}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='enabled'
        optionLabel={I18n.t('active')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name='display_supervision'
        optionLabel={I18n.t('display.supervision')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <SingleOptionSelectorField
        name={'bonus_heatmap'}
        optionLabel={I18n.t('heatmap.bonus_heatmap')}
        clearOnEmpty={false}
      />
    </Grid>
    <Grid size="grow">
      <TextField
        name={'display_index'}
        label={I18n.t('display.order')}
        type='number'
      />
    </Grid>
  </Grid>
)

const PrimarySection = props => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('info.general')}</Typography>
  </StepLabel>
  <StepContent >
    <Box sx={{ p: 5, boxShadow: 6, borderRadius: 3 }}>
      <Grid container rowSpacing={3}>
        <Row1 {...props} />
        <Row2 {...props} />
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(PrimarySection)
